const TooltipBody = ({ children }) => {
  return <div style={{ maxWidth: "350px", minWidth: "350px" }}>{children}</div>;
};

export { TooltipBody };
